import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { ListButton } from 'react-admin';

export const ReturnButton = () => {
  return (
    <ListButton name="return" label="Return" icon={<KeyboardReturnIcon/>}/>
  )
}